import { Spinner } from '@components/index';
import { FeeCategoryDataType, FormDataType, MemberListType } from '@types';
import { ValidationError } from 'types/requests';

import AttendanceBasedFeeSection from './AttendanceBasedFeeSection';
import AttendanceDetailsSection from './AttendanceDetailsSection';
import FeeDetailsSection from './FeeDetailsSection';
import GroupBasicDetails from './GroupBasicDetails';

interface BasicStepProps {
  formData: FormDataType;
  onInputChange: (field: string, value: any) => void;
  memberList: MemberListType[] | [];
  isFeeCategoryEnabled: boolean;
  setIsFeeCategoryEnabled: (value: boolean) => void;
  feeCategories: FeeCategoryDataType[];
  setFeeCategories: React.Dispatch<React.SetStateAction<FeeCategoryDataType[]>>;
  branchDetails: any;
  customTermDueDateError: ValidationError;
  setCustomTermDueDateError: (value: ValidationError) => void;
  feeDetailsError: ValidationError;
  setFeeDetailsError: (value: ValidationError) => void;
  endDateError: boolean;
  setEndDateError: (value: boolean) => void;
  hasGroupAttendanceEditAccess: boolean;
  handleAttendanceSwitchClick: (status: boolean) => void;
  isLoading: boolean;
  isAttendanceBasedFee: boolean;
  isEditGroup?: boolean;
}

const BasicStep = ({
  formData,
  onInputChange,
  memberList,
  isFeeCategoryEnabled,
  setIsFeeCategoryEnabled,
  feeCategories,
  setFeeCategories,
  branchDetails,
  customTermDueDateError,
  setCustomTermDueDateError,
  feeDetailsError,
  setFeeDetailsError,
  endDateError,
  setEndDateError,
  hasGroupAttendanceEditAccess,
  handleAttendanceSwitchClick,
  isLoading,
  isAttendanceBasedFee,
  isEditGroup = false
}: BasicStepProps) => {
  if (isLoading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="grid w-full gap-y-6">
      {/* Group name and image */}
      <GroupBasicDetails formData={formData} onInputChange={onInputChange} />

      {isAttendanceBasedFee ? (
        <AttendanceBasedFeeSection
          formData={formData}
          onInputChange={onInputChange}
        />
      ) : (
        <>
          {/* Fee details */}
          <FeeDetailsSection
            formData={formData}
            onInputChange={onInputChange}
            memberList={memberList}
            feeCategories={feeCategories}
            setFeeCategories={setFeeCategories}
            isFeeCategoryEnabled={isFeeCategoryEnabled}
            setIsFeeCategoryEnabled={setIsFeeCategoryEnabled}
            branchDetails={branchDetails}
            customTermDueDateError={customTermDueDateError}
            setCustomTermDueDateError={setCustomTermDueDateError}
            error={feeDetailsError}
            setError={setFeeDetailsError}
            endDateError={endDateError}
            setEndDateError={setEndDateError}
            isEditGroup={isEditGroup}
          />

          {/* Attendance details */}
          {hasGroupAttendanceEditAccess && (
            <AttendanceDetailsSection
              formData={formData}
              onInputChange={onInputChange}
              handleSwitchClick={handleAttendanceSwitchClick}
            />
          )}
        </>
      )}
    </div>
  );
};

export default BasicStep;
